<div *ngIf="field.isReadonly; else datepicker">
    <div class="field-label-value" name="txtName">
        {{ formData[field.key] | date }}
    </div>
</div>
<ng-template #datepicker>
    <tsl-form-field class="max-w">
        <tsl-datepicker [formControl]="dateFormControl" singleSelection></tsl-datepicker>
        <tsl-hint *ngIf="field.tooltip">{{ field.tooltip }}</tsl-hint>
    </tsl-form-field>
</ng-template>
